import React, { useEffect, useState } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import { useAuth } from '../services/authContext';
import { apiService } from '../services/apiService';
import { portalService } from '../services/portalService';

const MySubjects = () => {
  const { user } = useAuth();
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadSubjects = async () => {
      try {
        setLoading(true);
        setError('');
        const student = await portalService.getCurrentStudent(user.id);
        const moduleResponses = await Promise.all(
          (student.classIds || []).map(classId => apiService.get(`modules/class/${classId}`))
        );
        setSubjects(moduleResponses.flat());
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load your modules.');
      } finally {
        setLoading(false);
      }
    };

    if (user?.id) {
      loadSubjects();
    }
  }, [user]);

  if (loading) return <LoadingSpinner message="Loading your modules..." />;

  return (
    <div className="page-container">
      <div className="page-header"><h1>My Modules</h1></div>

      {error && <div className="error-message">{error}</div>}

      {subjects.length === 0 ? (
        <div className="no-data-message" style={{ textAlign: 'center', padding: '3rem' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📚</div>
          <h3>No modules found for your class</h3>
          <p>You haven't been assigned to any classes or modules yet. Please contact the administration office if you believe this is an error.</p>
        </div>
      ) : (
        <div className="card-grid">
          {subjects.map(subject => (
            <div key={`${subject._id}-${subject.classId || ''}`} className="class-card">
              <div className="class-card-header">
                <h2>{subject.code}</h2>
                <span className="class-room">{subject.teacherName || 'No teacher'}</span>
              </div>
              <div className="class-card-body">
                <p style={{ fontWeight: 600, marginTop: 0 }}>{subject.name}</p>
                <p><strong>Description:</strong> {subject.description || 'No description'}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MySubjects;
